module.exports = __webpack_public_path__ + "img/event_type_defence.cc277faf.svg";